import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="w-full py-20 px-4 md:px-8 bg-cream text-center" data-id="element-12">
      <motion.div className="max-w-3xl mx-auto" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-13">
        <h2 className="font-handwritten text-4xl md:text-5xl lg:text-6xl text-forest-green font-bold mb-6" data-id="element-14">
          Stärke den Darm deines Hundes – jeden Tag ein bisschen mehr
        </h2>

        <p className="text-xl text-gray-700 mb-10 font-serif" data-id="element-15">
          Natürliche Unterstützung für einen starken, gesunden Darm – risikofrei
          testen.
        </p>

        <a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-forest-green hover:bg-forest-green/90 text-white text-lg font-bold py-4 px-8 rounded-full transition-all hover:scale-105 shadow-lg hover:shadow-xl mb-8 w-full md:w-auto" data-id="element-16">
          Jetzt für meinen Hund entdecken
          <ArrowRight size={20} data-id="element-17" />
        </a>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-18">
          <div className="flex items-center gap-1" data-id="element-19">
            <Check size={16} className="text-forest-green" data-id="element-20" />
            <span data-id="element-21">Schneller Versand</span>
          </div>
          <div className="hidden md:block text-gray-300" data-id="element-22">•</div>
          <div className="flex items-center gap-1" data-id="element-23">
            <Check size={16} className="text-forest-green" data-id="element-24" />
            <span data-id="element-25">Zufriedenheitsgarantie</span>
          </div>
          <div className="hidden md:block text-gray-300" data-id="element-26">•</div>
          <div className="flex items-center gap-1" data-id="element-27">
            <Check size={16} className="text-forest-green" data-id="element-28" />
            <span data-id="element-29">100% Natürliche Inhaltsstoffe</span>
          </div>
        </div>
      </motion.div>
    </section>;
}